var _a;
/**
 * @hidden
 */
export var moveUp = 'listbox.moveUp';
/**
 * @hidden
 */
export var moveDown = 'listbox.moveDown';
/**
 * @hidden
 */
export var transferTo = 'listbox.transferTo';
/**
 * @hidden
 */
export var transferFrom = 'listbox.transferFrom';
/**
 * @hidden
 */
export var transferAllTo = 'listbox.transferAllTo';
/**
 * @hidden
 */
export var transferAllFrom = 'listbox.transferAllFrom';
/**
 * @hidden
 */
export var remove = 'listbox.remove';
/**
 * @hidden
 */
export var messages = (_a = {},
    _a[moveUp] = 'Move Up',
    _a[moveDown] = 'Move Down',
    _a[transferTo] = 'Transfer To',
    _a[transferFrom] = 'Transfer From',
    _a[transferAllTo] = 'Transfer All To',
    _a[transferAllFrom] = 'Transfer All From',
    _a[remove] = 'Delete',
    _a);
//# sourceMappingURL=index.js.map